import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useNavigate } from "@tanstack/react-router";
import { KeyRound } from "lucide-react";
import * as React from "react";
import { useState } from "react";

export function JoinWithCodeDialog({
  children,
}: { children?: React.ReactNode }) {
  const [code, setCode] = useState("");
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!code.trim()) return;

    setIsOpen(false);
    navigate({
      to: "/join/$code",
      params: { code: code.trim().toUpperCase() },
    });
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        {children || (
          <Button variant="outline" className="gap-2 text-foreground">
            <KeyRound className="h-4 w-4" />
            Kodla Katıl
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="overflow-hidden rounded-2xl border-border/40 bg-card p-0 sm:max-w-md">
        <div className="p-8">
          <DialogHeader className="space-y-3">
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-muted transition-transform hover:scale-110">
              <KeyRound className="h-8 w-8 text-primary" />
            </div>
            <DialogTitle className="text-center font-bold text-2xl tracking-tight">
              Koda Katıl
            </DialogTitle>
            <DialogDescription className="text-center text-sm leading-relaxed">
              Size iletilen 6 haneli özel erişim kodunu kullanarak programa
              anında dahil olabilirsiniz.
            </DialogDescription>
          </DialogHeader>
          <form onSubmit={handleSubmit} className="mt-8 space-y-6">
            <div className="space-y-3">
              <Label
                htmlFor="access-code"
                className="ml-1 font-bold text-muted-foreground text-xs uppercase tracking-wider"
              >
                Erişim Kodu
              </Label>
              <Input
                id="access-code"
                placeholder="ÖRN: 123456"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                className="h-14 rounded-xl border-border/40 bg-muted/50 text-center font-bold font-mono text-2xl uppercase tracking-[1em] transition-all placeholder:text-muted-foreground/30 placeholder:tracking-normal focus-visible:ring-primary/30"
                maxLength={6}
                autoFocus
              />
            </div>
            <Button
              type="submit"
              className="h-12 w-full font-bold transition-all active:scale-[0.98] disabled:opacity-50"
              disabled={code.length < 6}
            >
              Programa Kaydol
            </Button>
          </form>
        </div>
      </DialogContent>
    </Dialog>
  );
}
